<!-- Der Stage-Hinweis (Test/Demo) sitzt als Plakette in der Toolbar von lib-navigation. -->
<router-outlet></router-outlet>
